// extracted by mini-css-extract-plugin
export default {"container":"styles_container__oEhR6","gamelist":"styles_gamelist__skFhT"};